import { createApp } from '@backstage/frontend-defaults';
import { SignInPageBlueprint } from '@backstage/frontend-plugin-api';

import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import appPlugin from '@backstage/plugin-app';
import { apis, auth0AuthApiRef } from './apis';
import {
  techDocsReportIssueAddonModule,
  techDocsExpandableNavigationAddonModule,
  techDocsLightBoxAddonModule,
  techDocsTextSizeAddonModule,
} from '@backstage/plugin-techdocs-module-addons-contrib/alpha';

import appviaStyles from '@appvia/backstage-styles';

import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInConfigModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => {
          return (props: any) => (
            <SignInPage
              {...props}
              providers={[
                {
                  id: 'auth0-auth-provider',
                  title: 'Auth0',
                  message: 'Sign In using Auth0',
                  apiRef: auth0AuthApiRef,
                },
                ...(process.env.NODE_ENV === 'development' ? ['guest'] : []),
              ]}
            />
          );
        },
      },
    }),
    ...apis,
  ],
});

const app = createApp({
  features: [
    ...appviaStyles,

    appPlugin,

    signInConfigModule,

    // Default Backstage plugins
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    orgPlugin,
    searchPlugin,
    techdocsPlugin,
    techDocsReportIssueAddonModule,
    techDocsExpandableNavigationAddonModule,
    techDocsLightBoxAddonModule,
    techDocsTextSizeAddonModule,
    apiDocsPlugin,
    userSettingsPlugin,
    notificationsPlugin,
    kubernetesPlugin,
    signalsPlugin,
  ],

  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
});

export default app;
